import type React from "react"

export type AvatarSize = "sm" | "md" | "lg"

export interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: AvatarSize
  src?: string
  alt?: string
  fallback?: string
}

export const Avatar: React.FC<AvatarProps> = ({
  size = "md",
  src,
  alt = "Avatar",
  fallback,
  className = "",
  ...props
}) => {
  const classNames = ["avatar", `avatar-${size}`, className]
    .filter(Boolean)
    .join(" ")

  // 이미지 로드 실패 시 fallback 처리
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (fallback) {
      e.currentTarget.src = fallback
    }
  }

  return (
    <img
      className={classNames}
      src={src || `https://i.pravatar.cc/150?u=${alt}`}
      alt={alt}
      onError={handleError}
      {...props}
    />
  )
}